import { Component, Input } from '@angular/core';
import { FieldDataToShow } from '@app/models';
import { NotyService } from '@app/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-document-history-form-modal',
  templateUrl: './document-history-form-modal.component.html',
  styleUrl: './document-history-form-modal.component.scss',
  standalone: false
})
export class DocumentHistoryFormModalComponent {
  @Input() documentId: string;
  @Input() signerFieldsData: FieldDataToShow[];

  constructor(
    public modal: NgbActiveModal,
    private notyService: NotyService,
    private translateService: TranslateService
  ) {}

  copyFilledFieldsValues() {
    let clipboardText = '';
    for (let field of this.signerFieldsData) {
      clipboardText += `${field.name}: ${field.value}\n`;
    }
    navigator.clipboard
      .writeText(clipboardText.trim())
      .then(() => {
        this.notyService.success(this.translateService.instant('notyService.textCopiedToClipboard'));
      })
      .catch(e => {
        this.notyService.error(this.translateService.instant('notyService.unableToCopyToClipboard'));
      });
  }
}
